import {
  _sharedActionsConstantsSupport,
  _sharedActionsSupport,
} from "@/shared/store/support/actions";

export const supportActionConstants = {
  ..._sharedActionsConstantsSupport,
};

export const supportActions = {
  ..._sharedActionsSupport,
};
